import { apiRequestActions } from '@ackee/redux-utils';
import { fetchElevatorTypes } from './types';

export default apiRequestActions(fetchElevatorTypes, { isDetailRequest: true });
